import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from 'react-google-recaptcha';

const Form = () => {
  const form = useRef();
  const recaptchaRef = useRef(null);
  const [captchaValid, setCaptchaValid] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    const recaptchaValue = recaptchaRef.current.getValue();
    if (!recaptchaValue) {
      toast('Please verify the that you are not a robot.', {
        position: 'top-center',
        autoClose: 5000,
      });
      return;
    }
    emailjs
      .sendForm(process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, form.current, {
        publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      })
      .then(
        (response) => {
          if (response.status === 200) {
            toast.success('Thank you for your message! I will get back to you as soon as possible.', {
              position: 'top-center',
              autoClose: 5000,
            });
          } else {
            toast.error('Something went wrong. Please try again.', {
              position: 'top-center',
              autoClose: 5000,
            });
          }

          form.current.reset();
          recaptchaRef.current.reset();
          setCaptchaValid(false);
        },
        (error) => {
          console.error('Email sending error:', error);
          toast.error('Failed to send message. Please try again or contact me directly.', {
            position: 'top-center',
            autoClose: 5000,
          });
        }
      );
  };
  const onCaptchaChange = (value) => {
    setCaptchaValid(!!value);
  };
  return (
    <form
      ref={form}
      onSubmit={sendEmail}
      className="flex flex-col p-6 md:p-8 rounded-2xl justify-center items-center bg-green-100 bg-opacity-90 text-stone-950 w-full max-w-lg mx-auto shadow-lg"
    >
      <ToastContainer />
      <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center">Contact</h2>

      <label htmlFor="from_name" className="w-full mb-2 font-semibold text-base md:text-lg">
        Name:
      </label>
      <input
        type="text"
        id="from_name"
        name="from_name"
        required
        className="w-full p-3 md:p-4 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-base md:text-lg min-h-[44px]"
        placeholder="Your full name"
      />

      <label htmlFor="reply_to" className="w-full mb-2 font-semibold text-base md:text-lg">
        Email:
      </label>
      <input
        type="email"
        required
        id="reply_to"
        name="reply_to"
        className="w-full p-3 md:p-4 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-base md:text-lg min-h-[44px]"
        placeholder="your.email@example.com"
      />

      <label htmlFor="message" className="w-full mb-2 font-semibold text-base md:text-lg ">
        Message:
      </label>
      <textarea
        id="message"
        name="message"
        rows="5"
        required
        className="w-full p-3 md:p-4 mb-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-base md:text-lg resize-vertical min-h-[120px]"
        placeholder="Tell me about your fitness goals and how I can help you..."
      ></textarea>
      
      <div className="w-full flex justify-center mb-6">
        <ReCAPTCHA
          ref={recaptchaRef}
          required
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          onChange={onCaptchaChange}
          size="compact"
        />
      </div>
      
      <button
        type="submit"
        value="Send"
        className="w-full py-3 md:py-4 px-6 bg-teal-900 text-white font-semibold text-base md:text-lg rounded-lg hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 min-h-[48px]"
        disabled={!captchaValid}
      >
        Send Message
      </button>
    </form>
  );
};

export default Form;
